import React, {useEffect, useRef, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleMobileChatSidebar, infoToggle, sendMessage } from "./store";
import useWidth from "@/hooks/useWidth";
import {Icon} from "@/components/Icon.tsx";
import ProfileCircle from "@/pages/chat/ProfileCircle";
import {urlChatID, urlConversationID} from "@/utils/url.js";
import {useQuery, useQueryClient} from "react-query";
import {queryKey} from "@/store/queryKeys";
import {constants} from "@/constants.js";
import {timeAgo} from "@/utils/utils";
import Dropdown from "@/components/ui/Dropdown";
import {toast} from "react-toastify";

const messageAction = async (conversationID : string, bodyObj : any) => {
  try {
    let res = await fetch(
      `${constants.url.API_PREFIX}chatbot/${urlChatID()}/conversations/${conversationID}/message-action`,
      {
        method: "POST",
        body: JSON.stringify(bodyObj),
      },
    );
    let json = await res.json();
    if (json.error) {
      toast.error(json.error, {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    } else if (json.message) {
      toast.success(json.message, {
        position: "top-right",
        autoClose: 1500,
        theme: "light",
      });
    }
  } catch (e) {
    toast.error("Error", {
      position: "top-right",
      autoClose: 1500,
      theme: "light",
    });
  }
}

let prevUserID : any = null;
const Chat = () => {
  const { activechat, openinfo, mobileChatSidebar, messFeed, user } =
    useSelector((state : any) => state.chat);
  const { width, breakpoints } = useWidth();
  const dispatch = useDispatch();

  const [messages, setMessages] = useState([])

  let historyQuery = null;
  if (user?.id) {
    historyQuery = useQuery(
      queryKey.chatbotConversationHistory+'-'+user.id,
      async function () {
        let res = await fetch(
          `${constants.url.API_PREFIX}chatbot/${urlChatID()}/conversations/${user.id}`,
        );
        return res.json();
      },
    );
  }
  if (user.id != prevUserID) {
    prevUserID = user.id
  }

  const handleSendMessage = (e : any) => {
    if (e.target.value) {
      dispatch(
        sendMessage({
          content: e.target.value,
          sender: "me",
          // img: image1,
        })
      );
    }
    e.target.value = "";
  };
  const chatheight = useRef(null);
  useEffect(() => {
    if (chatheight.current) {
      let container = chatheight.current as HTMLElement
      container.scrollTop = container.scrollHeight;
    }
  }, [historyQuery?.data]);

  if (!historyQuery || !historyQuery.data) {
    return <p>Loading...</p>
  }

  return (
    <div className="h-full flex flex-col">
      <header className="border-b border-slate-100 dark:border-slate-700">
        <div className="flex py-6 md:px-6 px-3 items-center">
          <div className="flex-1">
            <div className="flex space-x-3 rtl:space-x-reverse">
              {width <= breakpoints.lg && (
                <span
                  onClick={() => dispatch(toggleMobileChatSidebar(true))}
                  className="text-slate-900 dark:text-white cursor-pointer text-xl self-center ltr:mr-3 rtl:ml-3"
                >
                  <Icon icon="heroicons-outline:menu-alt-1" />
                </span>
              )}
              <div className="flex-none">
                <div className="h-10 w-10 rounded-full relative">
                  <span
                    className={` status ring-1 ring-white inline-block h-[10px] w-[10px] rounded-full absolute -right-0 top-0
                  ${
                    user.status === "active"
                      ? "bg-success-500"
                      : "bg-secondary-500"
                  }
                  `}
                  ></span>
                  <ProfileCircle contact={user} />
                </div>
              </div>
              <div className="flex-1 text-start">
                <span className="block text-slate-800 dark:text-slate-300 text-sm font-medium mb-[2px] truncate">
                  {user.fullName}
                </span>
                <span className="block text-slate-500 dark:text-slate-300 text-xs font-normal">
                  {/*Active now*/}
                </span>
              </div>
            </div>
          </div>
          <div className="flex-none flex md:space-x-3 space-x-1 items-center rtl:space-x-reverse">
            {/*<div className="msg-action-btn">*/}
            {/*  <Icon icon="heroicons-outline:phone" />*/}
            {/*</div>*/}
            {/*<div className="msg-action-btn">*/}
            {/*  <Icon icon="heroicons-outline:video-camera" />*/}
            {/*</div>*/}

            <div
              onClick={() => dispatch(infoToggle(!openinfo))}
              className="msg-action-btn"
            >
              <Icon icon="heroicons-outline:dots-horizontal" />
            </div>
          </div>
        </div>
      </header>
      <div ref={chatheight} className="flex-1 overflow-y-auto">
        <div className="msgs py-6 space-y-6">
          {historyQuery?.data.map((item: any, i: number) => (
            <div className="block md:px-6 px-4" key={i}>
              {item.role === "assistant" && (
                <div className="flex space-x-2 items-start group rtl:space-x-reverse">
                  <div className="flex-none">
                    <div className="h-8 w-8 rounded-full">
                      <div className="block w-full h-full object-cover rounded-full bg-slate-200 flex items-center justify-center">
                        <Icon
                          className="mr-[1px]"
                          icon="fluent:bot-20-regular"
                          width="24"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex-1 flex space-x-4 rtl:space-x-reverse">
                    <div className="min-w-[120px]">
                      <div className="text-contrent p-3 bg-slate-100 dark:bg-slate-600 dark:text-slate-300 text-slate-600 text-sm font-normal mb-1 rounded-md flex-1 whitespace-pre-wrap break-all">
                        {item.message}
                      </div>
                      <span className="font-normal text-xs text-slate-400 dark:text-slate-400 flex justify-between items-center">
                        {timeAgo(new Date(item.created_at * 1000))}
                        {item.reaction && (
                            <Icon
                              icon={item.reaction == "positive" ? "fa:thumbs-o-up" : "fa:thumbs-o-down"}
                              width="1rem"
                              className="inline-block text-sky-500"
                            />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {/* sender */}
              {item.role === "user" && (
                <div className="flex space-x-2 items-start justify-end group w-full rtl:space-x-reverse">
                  <div className="no flex space-x-4 rtl:space-x-reverse">
                      <div className="opacity-0 invisible group-hover:opacity-100 group-hover:visible">
                        <Dropdown
                          classMenuItems="min-w-[200px] left-0 top-0"
                          items={[
                            {
                              label: "Add the question to Q&A",
                              onClick: () => {
                                messageAction(user.id, {
                                  action : "forward-to-qa",
                                  text: item.message
                                })
                              }
                            }
                          ] as any}
                          label={
                            <div className="h-8 w-8 bg-slate-300 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center text-xl rounded-full text-slate-900">
                              <Icon icon="heroicons-outline:dots-horizontal" />
                            </div>
                          }
                          children={undefined}
                        />
                      </div>
                    <div className="whitespace-pre-wrap break-all min-w-[120px]">
                      <div
                        className="relative text-contrent p-3 bg-slate-300 dark:bg-slate-900 dark:text-slate-300 text-slate-800 text-sm font-normal rounded-md flex-1 mb-1"
                        title={item.unknown_question ? "Unknown question" : ""}
                      >
                        {item.message}
                      </div>
                      <span className="font-normal text-xs text-slate-400 flex justify-between items-center">
                        {timeAgo(new Date(item.created_at * 1000))}
                        {item.unknown_question && (
                          <div title={item.unknown_question ? "Unknown question" : ""}>
                            <Icon
                              icon="fluent:warning-32-regular"
                              width="1.2rem"
                              className="inline-block text-sky-500"
                            />
                          </div>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="flex-none">
                    <div className="h-8 w-8 rounded-full">
                      <ProfileCircle contact={user} />
                    </div>
                  </div>
                </div>
              )}
              {/* me */}
            </div>
          ))}
        </div>
      </div>
      {/*<footer className="md:px-6 px-4 sm:flex md:space-x-4 sm:space-x-2 rtl:space-x-reverse border-t md:pt-6 pt-4 border-slate-100 dark:border-slate-700">*/}
      {/*  <div className="flex-none sm:flex hidden md:space-x-3 space-x-1 rtl:space-x-reverse">*/}
      {/*    <div className="h-8 w-8 cursor-pointer bg-slate-100 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center text-xl rounded-full">*/}
      {/*      <Icon icon="heroicons-outline:link" />*/}
      {/*    </div>*/}
      {/*    <div className="h-8 w-8 cursor-pointer bg-slate-100 dark:bg-slate-900 dark:text-slate-400 flex flex-col justify-center items-center text-xl rounded-full">*/}
      {/*      <Icon icon="heroicons-outline:emoji-happy" />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="flex-1 relative flex space-x-3 rtl:space-x-reverse">*/}
      {/*    <div className="flex-1">*/}
      {/*      <textarea*/}
      {/*        type="text"*/}
      {/*        placeholder="Type your message..."*/}
      {/*        className="focus:ring-0 focus:outline-0 block w-full bg-transparent dark:text-white resize-none"*/}
      {/*        // v-model.trim="newMessage"*/}
      {/*        // @keydown.enter.exact.prevent="sendMessage"*/}
      {/*        // @keydown.enter.shift.exact.prevent="newMessage += '\n'"*/}
      {/*        onKeyDown={(e) => {*/}
      {/*          if (e.key === "Enter" && !e.shiftKey) {*/}
      {/*            e.preventDefault();*/}
      {/*            handleSendMessage(e);*/}
      {/*          }*/}
      {/*        }}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    <div className="flex-none md:pr-0 pr-3">*/}
      {/*      <button*/}
      {/*        type="button"*/}
      {/*        className="h-8 w-8 bg-slate-900 text-white flex flex-col justify-center items-center text-lg rounded-full"*/}
      {/*      >*/}
      {/*        <Icon*/}
      {/*          icon="heroicons-outline:paper-airplane"*/}
      {/*          className="transform rotate-[60deg]"*/}
      {/*        />*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</footer>*/}
    </div>
  );
};

export default Chat;
